import { FC } from "react";
import PageTemplate from "../PageTemplate";
import WorkPage from "./WorkPage";

const Work: FC = () => {
    return <PageTemplate Page={WorkPage} />;
};

export default Work;
